/*******************************************************
ADD FIVE MAN PLAYER
Used on the five man stats page for NBA.
********************************************************/

import closeModalWindow from '../../universal/modal-window/close';
import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

export default async function openCourtOnOffModal(event) {
    const $button = $(event.currentTarget);
    const { player, court } = $button.data();

    const playerId = player;
    const courtOnOff = court;

    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : `/basketball/ajax/get-court-on-off-player.php`,
            data   : {
                player: playerId,
            },
            timeout: 10000,
        });

        const { playerHTML, success } = response;

        // Get the modal button
        const $modalButton = $('.open-court-on-off-modal[data-court="' + courtOnOff + '"]');

        // Prepend the player HTML to the add player button
        $modalButton.before(playerHTML);

        // If we have 5 or more players and we in the ON court section than hide the modal
        if($modalButton.siblings('.court-on-off-player').length >= 5 && courtOnOff === "on"){
            $modalButton.addClass('hide');
        }

        // Close the modal
        closeModalWindow();
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to add that player for you. Please try again.', 3000);
    }

}
